// extracted by mini-css-extract-plugin
module.exports = {"summaryMainWrapper":"summary_summaryMainWrapper__1Bk1L","title":"summary_title__2v75o","summaryWrapper":"summary_summaryWrapper__2jbc_"};